

import React from 'react';
import _get from 'lodash.get';
import { ADDON_ENTITY } from '@shootsta/common-domain-data';
import { MULTI, SINGLE } from '../../../../../constants/dropdownTypes';
import {
  VoiceOverArtistsV2,
  SingleVoiceArtist,
  Captions } from
'../../../../Expandable';




















export default function MasterOutputV2({
  video,
  appliedAddons,
  onChangeAddon,
  canUpdateOutput,
  editingMode = false,
  showAboutInfo,
  hideCaptions = false,
  hideVoiceOver = false,
  hideVoiceOvers = false,
  onInfoClick,
  resetAddonValuesByType,
  onOutputsSave,
  priceVersion,
  projectAssets,
  updateProject,
  onCaptionsToggleChange
}) {
  return (
    <div className="master-output-v2">
      <div className="master-output-v2__addons">
        {!hideCaptions &&
        <Captions
          onChangeAddon={onChangeAddon}
          burnInCaptions={_get(
            appliedAddons,
            ADDON_ENTITY.BURN_IN_CAPTIONS.type
          )}
          srtCaptions={_get(appliedAddons, ADDON_ENTITY.SRT_CAPTIONS.type)}
          dropdownType={editingMode ? MULTI : SINGLE}
          disabled={!canUpdateOutput}
          editingMode={editingMode}
          showAboutInfo={showAboutInfo}
          resetAddonValuesByType={resetAddonValuesByType}
          onCaptionsToggleChange={onCaptionsToggleChange} />}


        {!hideVoiceOver &&
        <SingleVoiceArtist
          voiceOverArtist={_get(
            appliedAddons,
            ADDON_ENTITY.VOICE_OVER_ARTIST.type
          )}
          onChangeAddon={onChangeAddon('VOICE_OVER_ARTIST')}
          disabled={!canUpdateOutput}
          onInfoClick={onInfoClick}
          editingMode={editingMode}
          showAboutInfo={showAboutInfo} />}


        {!hideVoiceOvers &&
        <VoiceOverArtistsV2
          video={video}
          onChangeAddon={onChangeAddon('VOICE_OVER_ARTISTS')}
          onOutputsSave={onOutputsSave}
          priceVersion={priceVersion}
          onInfoClick={onInfoClick}
          voiceOverArtists={_get(appliedAddons, 'VOICE_OVER_ARTISTS') || []}
          canUpdateVideo={canUpdateOutput}
          projectAssets={projectAssets || []}
          resetAddonValuesByType={resetAddonValuesByType}
          updateProject={updateProject} />}


      </div>
    </div>);

}